import { ReactNode } from 'react'
import { useMediaQueries } from 'builder/hooks/useMediaQueries'
import { useResumeDistributionABTest } from '../../hooks/useResumeDistributionABTest'
import { DistributionPromo } from '../DistributionPromo/DistributionPromo'
import { ResumeDistributionLayoutContainer, ContentContainer } from './styles'

type Props = {
  children: ReactNode
}

export const ResumeDistributionLayout = (props: Props) => {
  const { children } = props
  const { isResumeDistributionV2ABTestActive } = useResumeDistributionABTest()
  const { isAboveTablet } = useMediaQueries()

  return isResumeDistributionV2ABTestActive ? (
    <ResumeDistributionLayoutContainer>
      <ContentContainer>{children}</ContentContainer>
      {isAboveTablet && <DistributionPromo />}
    </ResumeDistributionLayoutContainer>
  ) : (
    <>{children}</>
  )
}
